import React from 'react'
import styles from '../../styles/company.module.css';
import { IMAGEPATH } from '../../constants/imagePath';
import { KR } from '../../constants/localizations';

export default function CompanyOverviewSection() {
    return (
        <div className={styles.overview}>
            <div className={styles.title}>
                <h2>{KR.label_company_overview_title}
                </h2>
                <h2 className={styles.titleM}>AR247<br />완전 무인 자율주행의<br />새로운 패러다임</h2>
                <span>{KR.label_company_overview}</span>
            </div>
            <div className={styles.content}>
                <div>
                    <img src={IMAGEPATH.machine} srcSet={IMAGEPATH.machineWebp} alt="machine" loading="lazy" />
                </div>
                <div>
                    <h3>
                        <span>
                            {KR.label_home_autonomous_lab}
                        </span>
                        {KR.label_home_autonomous_lab_eng}
                    </h3>
                    <div>
                        <p>
                            {KR.label_company_overview_content_a}
                        </p>
                        <p>
                            {KR.label_company_overview_content_b}
                        </p>
                        <p>
                            {KR.label_company_overview_content_c}
                        </p>
                    </div>
                </div>
            </div>

        </div>
    )
}
